import { Work } from "@biblioteksentralen/cordata";
import { useWorkViewData } from "../components/works/WorkViewBanner/useWorkViewData";
import { getRelevantManifestations } from "../cordata/manifestations";

export const useManifestationIdsForWork = (work: Work) => {
  const { currentLanguagesList, currentDocumentType } = useWorkViewData(work);
  const relevantManifestations = getRelevantManifestations(work, currentLanguagesList, currentDocumentType);
  return relevantManifestations.map(({ id }) => id);
};
